import React from 'react';
import {Platform, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import NetInfo from '@react-native-community/netinfo';
import Styles from 'src/components/Styles';
import AppRoutes from 'src/AppRoutes';
import HistoryIcon from 'src/components/img/svg/HistoryIcon';
import RewardsIcon from 'src/components/img/svg/RewardsIcon';
import WalletIcon from 'src/components/img/svg/WalletIcon';
import HomeIcon from 'src/components/img/svg/HomeIcon';
import Localized from 'src/constants/AppStrings';
import Settings from 'src/Settings';
import AccountTabIcon from 'src/components/img/svg/AccountTabIcon';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import PayIcon from 'src/components/img/svg/PayIcon';
import HomeRevolveIcon from 'src/components/img/svg/HomeRevolveIcon';
import RewardsDefaultIcon from 'src/components/img/svg/RewardsDefaultIcon';
import BuildTypeConstants from 'src/constants/BuildTypeConstants';
import HomeIconLight from 'src/components/img/svg/HomeIconLight';
import OffersTabIcon from 'src/components/img/svg/OffersTabIcon';
import AccountRedesignDarkIcon from 'src/components/img/svg/AccountRedesignDarkIcon';
import AccountRedesignLightIcon from 'src/components/img/svg/AccountRedesignLightIcon';
import {getFooterDescriber} from 'src/components/elements/footerDescriptor/DescriptorType';
import RewardsFocussedIcon from 'src/components/img/svg/RewardsFocussedIcon';

const BottomTabBar = ({state, descriptors, navigation}) => {
  const inset = useSafeAreaInsets();
  let label: string;

  const getTabColor = (isFocused: boolean) => {
    if (Settings.buildType === BuildTypeConstants.default) {
      return isFocused ? Styles.footerTabActive : Styles.footerTabInactive;
    } else if (Settings.buildType === BuildTypeConstants.refive) {
      return isFocused
        ? Styles.Colors.Refive.activeFooterBlue
        : Styles.footerTabInactive;
    } else if (Settings.buildType === BuildTypeConstants.canteen) {
      return isFocused
        ? Styles.Colors.Canteen.darkGreen
        : Styles.Colors.PayLegacy.grayScaleBase03;
    } else if (Settings.buildType === BuildTypeConstants.companykitchen) {
      return isFocused
        ? Styles.Colors.CompanyKitchen.blue
        : Styles.Colors.PayLegacy.grayScaleBase03;
    } else {
      return isFocused ? Styles.blueRevolve : Styles.lightGray;
    }
  };

  /** function to toggle icon color active/inactive  */
  const getTabIcon = (routeName: AppRoutes, isFocused: boolean) => {
    const color = getTabColor(isFocused);
    if (
      Settings.buildType === BuildTypeConstants.default ||
      Settings.buildType === BuildTypeConstants.refive
    ) {
      switch (routeName) {
        case AppRoutes.Offers:
          return (
            <View style={{marginVertical: Styles.Spacing.m1}}>
              <OffersTabIcon color={color} />
            </View>
          );
        case AppRoutes.Rewards:
          return isFocused ? (
            <RewardsFocussedIcon />
          ) : (
            <RewardsDefaultIcon color={color} />
          );
        case AppRoutes.HomeTab:
          return isFocused ? (
            <HomeRevolveIcon color={color} />
          ) : (
            <HomeIconLight color={color} />
          );
        case AppRoutes.Account:
          return isFocused ? (
            <AccountRedesignDarkIcon width={35} height={34} />
          ) : (
            <AccountRedesignLightIcon width={35} height={34} />
          );
        case AppRoutes.PayTab:
          return <PayIcon color={color} isFocused={isFocused} />;
        default:
          return null;
      }
    } else if (
      Settings.buildType === BuildTypeConstants.canteen ||
      Settings.buildType === BuildTypeConstants.companykitchen
    ) {
      switch (routeName) {
        case AppRoutes.Wallet:
          return <WalletIcon color={color} />;
        case AppRoutes.Rewards:
          return (
            <View style={{marginLeft: Styles.Spacing.m2}}>
              <RewardsIcon color={color} />
            </View>
          );
        case AppRoutes.History:
          return <HistoryIcon color={color} />;
        case AppRoutes.Account:
          return <AccountTabIcon color={color} />;
        case AppRoutes.HomeTab:
          return <HomeIcon color={color} />;
        default:
          return null;
      }
    }
  };

  /** function tab press */
  const onPress = async (route, isFocused: boolean) => {
    const event = navigation.emit({
      type: 'tabPress',
      target: route.key,
    });
    try {
      const networkState = await NetInfo.fetch();
      /** function check network */
      if (
        !networkState?.isConnected &&
        (route.name === Localized.Labels.wallet ||
          route.name === Localized.Labels.rewards ||
          route.name === Localized.Labels.history ||
          route.name === Localized.Labels.scan ||
          route.name === Localized.Labels.offers ||
          route.name === Localized.Labels.account ||
          route.name === Localized.Labels.home)
      ) {
        // networkError();
      }
      if (!isFocused && !event.defaultPrevented) {
        navigation.navigate(route.name);
      }
    } catch (err) {

    }
  };
  return (
    <View style={[styles.container, {paddingBottom: inset.bottom}]}>
      {state.routes.map((route, index) => {
        const {options} = descriptors[route.key];
        if (options.tabBarLabel !== undefined) {
          label = options.tabBarLabel;
        } else if (options.title !== undefined) {
          label = options.title;
        } else {
          label = route.name;
        }

        const isFocused = state.index === index;
        return (
          <View
            key={index}
            accessible={true}
            accessibilityLabel={options.tabBarAccessibilityLabel}
            aria-label={options.tabBarAccessibilityLabel}
            testID={options.tabBarTestID}
            style={{
              ...styles.tabView,
            }}
          >
            <View
              style={{
                borderTopColor: isFocused
                  ? getFooterDescriber().bottomTabBtnColor()
                  : 'transparent',
                borderTopWidth: isFocused ? 3 : 0,
                width: 44,
                position: 'absolute',
                top: 0,
              }}
            />
            <TouchableOpacity
              key={index}
              accessible={true}
              accessibilityRole="button"
              accessibilityState={isFocused ? {selected: true} : {}}
              accessibilityLabel={options.tabBarAccessibilityLabel}
              aria-label={options.tabBarAccessibilityLabel}
              testID={options.tabBarTestID}
              onPress={() => onPress(route, isFocused)}
              style={styles.btnStyle}
            >
              <View
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: Styles.Heights.h1,
                  paddingBottom:
                    Platform.OS === 'android' ? Styles.Heights.h1 : 0,
                }}
              >
                {getTabIcon(route.name, isFocused)}
                <Text
                  accessible={true}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
                  accessibilityLabel={label}
                  aria-label={label}
                  testID={label}
                  style={[
                    getFooterDescriber().getFooterNameTextDesc(isFocused)[
                      'footerNameText'
                    ],
                    {
                      color: getTabColor(isFocused),
                    },
                  ]}
                >
                  {label.toUpperCase()}
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        );
      })}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: Styles.white,
  },
  tabView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: Styles.Heights.h1,
    backgroundColor: Styles.white,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: Styles.Colors.PayNew.neutralHuesBase09,
  },
  btnStyle: {
    minHeight: Styles.Heights.touchTargetHeight2,
    minWidth: Styles.Heights.touchTargetHeight2,
  },
});
export default BottomTabBar;
